import React, {Component} from 'react';
import {withStyles} from 'material-ui/styles';
import PropTypes from 'prop-types'

import Button from 'material-ui/Button';
import Popover from 'material-ui/Popover';
import MoreVertIcon from 'material-ui-icons/MoreVert';

import Radio, {RadioGroup} from 'material-ui/Radio';
import {FormLabel, FormControl, FormControlLabel, FormGroup} from 'material-ui/Form';
import Switch from 'material-ui/Switch';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing.unit * 2,
  },
  button: {
    width:36,
    height:36,
    boxShadow: '0px 3px 3px -1px rgba(0, 0, 0, 0.2)'
  },
  group: {
    margin: `${theme.spacing.unit / 2}px 0`,
  },
});

class ChartOptions extends Component {
  state = {
    anchorEl: null,
    open: false,
  };

  handleClick = event => {
    this.setState({open: true, anchorEl: event.currentTarget});
  };

  handleRequestClose = () => {
    this.setState({open: false});
  };

  handleChange = (event, value) => {
    this.props.onTypeChange(value);
  };

  handleSwitchChange = (event, value) => {
    this.props.onFilterChange(value);
  };

  render() {
    const classes = this.props.classes;

    return (
      <div>
        <Button
          fab
          dense
          raised={false}
          elevation={0}
          color="primary"
          aria-label="More"
          aria-owns={this.state.open ? 'long-menu' : null}
          aria-haspopup="true"
          className={classes.button}
          onClick={this.handleClick}>
          <MoreVertIcon/>
        </Button>
        <Popover
          id="long-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onRequestClose={this.handleRequestClose}
          transformOrigin={{vertical: 'top', horizontal: 'left'}}
          anchorOrigin={{vertical: 'top', horizontal: 'left'}}>
          <div className={classes.root}>
            <FormGroup>
              <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">Chart Type</FormLabel>
                <RadioGroup
                  aria-label="types"
                  name="types"
                  className={classes.group}
                  value={this.props.shotType}
                  onChange={this.handleChange}>
                  <FormControlLabel value="bins" control={<Radio/>} label="Hexagon Bins"/>
                  {/*<FormControlLabel value="circles" control={<Radio/>} label="Circle Bins"/>*/}
                  <FormControlLabel value="zones" control={<Radio/>} label="Zones"/>
                  <FormControlLabel value="shots" control={<Radio/>} label="Raw Shots"/>
                  <FormControlLabel value="zoneshots" control={<Radio/>} label="Shots & Zones"/>
                  <FormControlLabel value="hexshots" control={<Radio/>} label="Shots & Hexagons"/>
                </RadioGroup>
              </FormControl>
              <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel>Minimum Bin Shots</FormLabel>
              <FormControlLabel
                disabled={this.props.shotType !== 'bins' && this.props.shotType !== 'circles'}
                control={<Switch checked={this.props.shotsFiltered}/>}
                onChange={this.handleSwitchChange}
                label="Hide 1 Shot Bins"/>
              </FormControl>
            </FormGroup>
          </div>
        </Popover>
      </div>
    );
  }
}

ChartOptions.propTypes = {
  shotType: PropTypes.string,
  shotsFiltered: PropTypes.bool,
  onTypeChange: PropTypes.func,
  onFilterChange: PropTypes.func
};

export default withStyles(styles)(ChartOptions);



// WEBPACK FOOTER //
// ./src/components/ChartOptions.js